import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-slider-item-fyroro';
const html = `
<div>
  <div class="container">
    <div class="wrap-card">
      <div data-attribute="title-card" class="card-title">
        <h2 style="text-align: center;">Shop All Fyroro Products</h2>
      </div>
      <div
        data-show-discount-tag="true"
        data-background-discount-tag="#6293c1"
        data-color-discount-tag="#ffffff"
        data-show-price="true"
        data-attribute="slider-product"
        data-slide-per-view="3"
        class="slider-product"
        style="--color-discount-tag: #ffffff; --background-discount-tag: #6293c1;"
      >
        <div class="swiper">
          <div data-attribute="list-item" class="swiper-wrapper">
            <div class="swiper-slide">
              <a href="#" data-attribute="item-product" class="wrap-item">
                <div class="wrap-img">
                  <img
                    data-attribute="image-product"
                    src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e68dd81c65a6649e6ae8.webp"
                    alt=""
                  />
                  <div data-attribute="save-discount" data-show="true" class="save-discount">
                    <span class="icon-discount">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-discount color-foreground-text"
                        viewBox="0 0 12 12"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </span>
                    <span data-attribute="text-discount" class="text-discount">Save 20%</span>
                  </div>
                </div>
                <div class="wrap-content">
                  <div data-attribute="product-name" class="product-name">FYRORO® Signal</div>
                  <div class="product-price">
                    <span data-attribute="from-text" class="from-text">From</span>
                    <span data-attribute="price-new" class="price-new">$9.99</span>
                    <span data-attribute="price-old" class="price-old">$120.99</span>
                  </div>
                </div>
              </a>
            </div>
            <div class="swiper-slide">
              <a href="#" data-attribute="item-product" class="wrap-item">
                <div class="wrap-img">
                  <img
                    data-attribute="image-product"
                    src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e6923c39013937b17bcc.webp"
                    alt=""
                  />
                  <div data-attribute="save-discount" data-show="true" class="save-discount">
                    <span class="icon-discount">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-discount color-foreground-text"
                        viewBox="0 0 12 12"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </span>
                    <span data-attribute="text-discount" class="text-discount">Save 20%</span>
                  </div>
                </div>
                <div class="wrap-content">
                  <div data-attribute="product-name" class="product-name">FYRORO® Signal</div>
                  <div class="product-price">
                    <span data-attribute="from-text" class="from-text">From</span>
                    <span data-attribute="price-new" class="price-new">$9.99</span>
                    <span data-attribute="price-old" class="price-old">$120.99</span>
                  </div>
                </div>
              </a>
            </div>
            <div class="swiper-slide">
              <a href="#" data-attribute="item-product" class="wrap-item">
                <div class="wrap-img">
                  <img
                    data-attribute="image-product"
                    src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e697dad78fd7a5067bd8.webp"
                    alt=""
                  />
                  <div data-attribute="save-discount" data-show="true" class="save-discount">
                    <span class="icon-discount">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-discount color-foreground-text"
                        viewBox="0 0 12 12"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </span>
                    <span data-attribute="text-discount" class="text-discount">Save 20%</span>
                  </div>
                </div>
                <div class="wrap-content">
                  <div data-attribute="product-name" class="product-name">FYRORO® Signal</div>
                  <div class="product-price">
                    <span data-attribute="from-text" class="from-text">From</span>
                    <span data-attribute="price-new" class="price-new">$9.99</span>
                    <span data-attribute="price-old" class="price-old">$120.99</span>
                  </div>
                </div>
              </a>
            </div>
            <div class="swiper-slide">
              <a href="#" data-attribute="item-product" class="wrap-item">
                <div class="wrap-img">
                  <img
                    data-attribute="image-product"
                    src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e69b057b2c54e5fe2020.webp"
                    alt=""
                  />
                  <div data-attribute="save-discount" data-show="true" class="save-discount">
                    <span class="icon-discount">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-discount color-foreground-text"
                        viewBox="0 0 12 12"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </span>
                    <span data-attribute="text-discount" class="text-discount">Save 20%</span>
                  </div>
                </div>
                <div class="wrap-content">
                  <div data-attribute="product-name" class="product-name">FYRORO® Signal</div>
                  <div class="product-price">
                    <span data-attribute="from-text" class="from-text">From</span>
                    <span data-attribute="price-new" class="price-new">$9.99</span>
                    <span data-attribute="price-old" class="price-old">$120.99</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="wrap-pagination">
          <div class="swiper-pagination"></div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
        <div data-show-btn="true" class="wrap-btn" style="display: block;">
          <a
            data-background="#000000"
            data-color="#ffffff"
            data-radius="10"
            href="javascript:void(0)"
            data-attribute="btn-view-all"
            class="btn-view-all"
            style="background: #000000; color: #fff; border-radius: 10px"
            >View All</a
          >
        </div>
      </div>
    </div>
  </div>
</div>

`;

export default containerFuild(html, css);
